/**
 * Created by idea on 03/07/2017.
 */
import { Component, OnDestroy, OnInit } from '@angular/core';

declare var jQuery: any;

@Component({
  selector: 'blank',
  templateUrl: 'blank.template.html',
})
export class blankComponent implements OnInit, OnDestroy {
  constructor() {}

  ngOnInit(): void {
    document.body.style.removeProperty('zoom');
    document.body.style.removeProperty('padding-top');
  }

  ngOnDestroy(): void {
    document.body.style.paddingTop = '50px';
    (document.body.style as any).zoom = '93%';
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/layouts/blank.component.ts